import { render, staticRenderFns } from "./GrupoMenuAdmin.vue?vue&type=template&id=673409cc"
import script from "./GrupoMenuAdmin.vue?vue&type=script&lang=js"
export * from "./GrupoMenuAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports